const PREFIX = 'APP_';

export const SET_LOADING = `${PREFIX}SET_LOADING`;
export const UNSET_LOADING = `${PREFIX}UNSET_LOADING`;
export const LOAD_ME = `${PREFIX}LOAD_ME`;
export const CHANGE_SELECTED_MEMBER_GROUP = `${PREFIX}CHANGE_SELECTED_MEMBER_GROUP`;
export const SET_GLOBAL_ERROR_MESSAGE = `${PREFIX}_SET_GLOBAL_ERROR_MESSAGE`;
